import {
  LayoutDashboard,
  IndianRupee,
  Layers,
  Map,
  Users,
  FlaskConical,
  Landmark,
} from 'lucide-react';

/** Corporate workspace routes (static data screens). */
export const CORPORATE_WORKSPACE_ROUTES = [
  {
    id: 'command',
    route: 'alerts',
    path: '/corporate/alerts',
    label: 'Alerts',
    shortLabel: 'Alerts',
    icon: LayoutDashboard,
    screen: 1,
  },
  {
    id: 'costs',
    route: 'costs',
    path: '/corporate/costs',
    label: 'Costs',
    shortLabel: 'Costs',
    icon: IndianRupee,
    screen: 2,
  },
  {
    id: 'china',
    route: 'china-exposure',
    path: '/corporate/china-exposure',
    label: 'China exposure',
    shortLabel: 'China',
    icon: Layers,
    screen: 3,
  },
  {
    id: 'planb',
    route: 'plan-b',
    path: '/corporate/plan-b',
    label: 'Plan B',
    shortLabel: 'Plan B',
    icon: Map,
    screen: 4,
  },
  {
    id: 'shipping',
    route: 'shipping',
    path: '/corporate/shipping',
    label: 'Shipping',
    shortLabel: 'Shipping',
    icon: Landmark,
    screen: 5,
  },
  {
    id: 'competitors',
    route: 'competitors',
    path: '/corporate/competitors',
    label: 'Competitors',
    shortLabel: 'Competitors',
    icon: Users,
    screen: 6,
  },
  {
    id: 'scenarios',
    route: 'scenarios',
    path: '/corporate/scenarios',
    label: 'Scenarios',
    shortLabel: 'Scenarios',
    icon: FlaskConical,
    screen: 7,
  },
];

/** @deprecated Use CORPORATE_WORKSPACE_ROUTES — kept for feature-flag ids */
export const CORPORATE_WORKSPACE_TABS = CORPORATE_WORKSPACE_ROUTES;

/** Feature flags for admin toggles and plan features (corporate:tabId). */
export function corporatePageFeature(tabId) {
  return `corporate:${tabId}`;
}

export const CORPORATE_PAGE_FEATURES = CORPORATE_WORKSPACE_ROUTES.map((t) =>
  corporatePageFeature(t.id),
);

export function corporateSlugFromPathname(pathname) {
  const base = '/corporate/';
  if (!pathname.startsWith(base)) return null;
  const slug = pathname.slice(base.length).split('/')[0];
  return slug || null;
}

export function corporateRouteBySlug(slug) {
  return CORPORATE_WORKSPACE_ROUTES.find((r) => r.route === slug) || CORPORATE_WORKSPACE_ROUTES[0];
}

export function corporateRouteToTabId(routeSlug) {
  return corporateRouteBySlug(routeSlug).id;
}
